export default __webpack_public_path__ + "images/96dba7457f48728df031bf3b58de8036-music_tablet.webp";